"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useStyles = {
    "invosys-ui-Layout": {
        width: "90%",
        maxWidth: "1400px",
        margin: "0px auto",
        padding: "16px 0",
        maxHeight: "calc(100vh - 32px)",
        height: "100%",
        display: "flex",
        msDisplay: "flex",
        flexDirection: "column"
    },
    "invosys-ui-Layout-dense": {
        width: "90%",
        maxWidth: "1400px",
        margin: "0px auto",
        padding: "8px 0",
        maxHeight: "calc(100vh - 16px)",
        height: "100%",
        display: "flex",
        msDisplay: "flex",
        flexDirection: "column"
    },
    "invosys-ui-Layout-navigation": { flex: "0 1 0" },
    "invosys-ui-Layout-searchBar": {
        flex: "0 1 0",
        marginBottom: "16px",
        padding: "8px 8px 16px 8px"
    },
    "invosys-ui-Layout-searchBar-dense": {
        flex: "0 1 0",
        marginBottom: "8px",
        padding: "8px 8px 16px 8px"
    },
    "invosys-ui-Layout-content": {
        flex: "1 1 0",
        overflow: "auto",
        minHeight: "30vh"
    }
};
exports.default = useStyles;
